module.exports = __webpack_public_path__ + "img/sign.3456ab36.png";